import React, { useState, useEffect } from "react";
import {
  TextField,
  Checkbox,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  Tooltip,
  Divider,
  Box,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDispatch, useSelector } from "react-redux";
import { FORM_KEYS } from "../utills/constant";
import { motion } from "framer-motion";
import { saveOutPutOcrFinalFields } from "../redux/slices/CreateAgentSlice";

const OutputFieldList = ({  isOutput }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const formDetails = useSelector((state) => state.CreateAgentSlice.formDetails);

  const dispatch = useDispatch();
  const [items, setItems] = useState([]
  );
  useEffect(() => {
    if (formDetails[FORM_KEYS.OCR_FIELDS]) {
      console.log('formDetails',formDetails)
      const updatedItems = formDetails[FORM_KEYS.OCR_FIELDS].map((item, index) => ({
        id: index,
        label: item?.label,
        keys:item?.key?.replace("_"," "),
        checked: true,
        disabled: false, // Toggle this as needed
      }));
      console.log('updatedItems',updatedItems)
      setItems(updatedItems);
    }
  }, [formDetails]);
  const [selectAll, setSelectAll] = useState(false);


 // Handle search filter
 const filteredItems = Array.isArray(items) 
 ? items.filter((item) =>
     item?.label?.toLowerCase().includes(searchTerm?.toLowerCase())
   )
 : [];





// Handle individual checkbox change
const handleCheckboxChange = (id) => {
  setItems((prevItems) => {
    const updatedItems = prevItems.map((item) =>
      item.id === id ? { ...item, checked: !item.checked } : item
    );

    const output = updatedItems
      .filter((item) => item.checked) // Only checked items
      .map((item) => ({
        key: item.keys,
        label: item.label,
      }));

    dispatch(saveOutPutOcrFinalFields(output)); // Dispatch updated output

    return updatedItems; // Update state with toggled item
  });
};



  // Handle "Select All" checkbox change
  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.disabled ? item : { ...item, checked: !selectAll }
      )
    );
  };

  return (
    <Box
      sx={{
        border: "1px solid #ddd",
        borderRadius: "12px",
        p: 2,
        backgroundColor: "white",
      }}
    >
      {/* Search Box */}
      <TextField
        placeholder="Search"
        variant="outlined"
        fullWidth
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#000" }} />
            </InputAdornment>
          ),
        }}
        sx={{
          mb: 2,
          "& .MuiOutlinedInput-root": {
            borderRadius: "25px",
            backgroundColor: "#fff",
          },
        }}
      />

      {/* "Select All" Checkbox */}
      <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
        <Checkbox
          checked={selectAll}
          onChange={handleSelectAll}
          icon={<CheckBoxOutlineBlankIcon />}
          checkedIcon={<CheckBoxIcon style={{ color: "black" }} />}
          sx={{
            color: selectAll ? "#000" : "#ccc",
            "&.Mui-checked": {
              color: "black",
            },
          }}
        />
        <Typography fontWeight="bold">Select All</Typography>
      </Box>
      <Divider />

      {/* Categories and Items */}
      <List>
        {filteredItems?.map((item) => (

          <ListItem key={item.id} disablePadding>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={item.checked}
                disabled={item.disabled}
                onChange={() => handleCheckboxChange(item.id)}
                icon={<CheckBoxOutlineBlankIcon />}
                checkedIcon={<CheckBoxIcon style={{ color: "black" }} />}
              />
            </ListItemIcon>
                  {/* Tooltip added to show label on hover */}
                  <Tooltip
              title={
                <motion.div
                  initial={{ opacity: 0, scale: 0.9, y: 5 }} // Start slightly smaller & lower
                  animate={{ opacity: 1, scale: 1, y: 0 }} // Smooth scale up effect
                  exit={{ opacity: 0, scale: 0.9, y: 5 }} // Fade out effect
                  transition={{ duration: 0.3, ease: "easeOut" }} // Smooth timing
                >
                  <Typography
                    sx={{ fontSize: "16px", fontWeight: "bold", p: 1 }}
                  >
                    {item.label}
                  </Typography>
                </motion.div>
              }
              arrow
              placement="bottom-start"
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#333",
                    color: "#fff",
                    fontSize: "16px",
                    borderRadius: "8px",
                    padding: "10px",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
                  },
                },
                arrow: {
                  sx: {
                    color: "#333",
                    marginLeft: "-8px",
                  },
                },
              }}
            >
              <motion.div
                whileHover={{
                  backgroundColor: "#f0f0f0", // Light gray background on hover
                  scale: 1.05, // Slightly increase size
                  transition: { duration: 0.2 }, // Smooth transition
                }}
                style={{
                  borderRadius: "8px",
                  padding: "4px 8px",
                  cursor: "pointer",
                }}
              >
                <Typography>{item.keys}</Typography>
              </motion.div>
            </Tooltip>
       
         
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default OutputFieldList;
